const getBucketServiceParams = (controller?: AbortController) => ({
  query: { $download: true },
  connection: { responseType: 'blob', signal: controller?.signal },
});

export default getBucketServiceParams;
